import type { FC } from 'react';
import React from 'react';

import { Box } from '@mui/material';

import { ArrowDownSmallIcon } from '@setup/svg-icons/svg-icons';
import theme from '@setup/theme/theme';

import type { OptionType } from './types';
import type { DropdownIndicatorProps } from 'react-select';

type DropdownIndicatorExtraProps = {
  classNameForTargetUserOnboardingTooltip?: string;
};

export const DropdownIndicator: FC<DropdownIndicatorProps<OptionType> & DropdownIndicatorExtraProps> = ({
  hasValue,
  isFocused,
  classNameForTargetUserOnboardingTooltip,
  selectProps: { menuIsOpen, isClearable, isDisabled },
}) => {
  return (
    <Box
      sx={{
        width: '24px',
        height: '24px',
        display: hasValue && isFocused && isClearable ? 'none' : 'flex',
        transform: menuIsOpen ? 'rotate(-180deg)' : 'rotate(0)',
        cursor: 'pointer',
        alignItems: 'center',
        svg: {
          path: {
            fill: isDisabled ? theme.palette.case.neutral.n300 : theme.palette.case.neutral.n500,
          },
        },
      }}
    >
      <ArrowDownSmallIcon className={classNameForTargetUserOnboardingTooltip} />
    </Box>
  );
};
